import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ClassResponse } from '../models/class-response';
import { HttpAction } from '../studio-http-client/http-action.enum';

@Injectable({
  providedIn: 'root',
})
export class ClassesService {
  apiService = inject(ApiService);

  getClassesByStudent(studentId: string, context: HttpContext = null): Observable<ClassResponse[]> {
    const getURL = `api/Students/${studentId}/Classes`;
    return this.apiService.invokeLSApi<ClassResponse[]>(getURL, HttpAction.Get, null, { context });
  }
}
